function cardSecurityCodeDirective() {
    'ngInject';

    const linker = (scope, element, attributes) =>
        scope.$watch('cardType', (newValue) => {
            if (newValue === 'american_express') {
                element.attr('maxlength', 4);
                return element.attr('placeholder', '••••');
            } else {
                element.attr('maxlength', 3);
                return element.attr('placeholder', '•••');
            }
        });

    return {
        restrict: 'AC',
        link: linker,
        scope: {
            cardType: '='
        }
    };
}

angular
    .module('BB.inputs')
    .directive('cardSecurityCode', cardSecurityCodeDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-inputs/card-security-code/card_security_code.directive.js